export const sampleSnapshot = {
  company: {
    name: "Demo Corp",
    ticker: "DEMO",
    exchange: "NASDAQ",
    sector: "Technology",
    price: 182.34,
    price_change: 1.24,
  },
  metrics: [
    { label: "Revenue", value: 123.4, unit: "B" },
    { label: "Profit Margin", value: 23.5, unit: "%" },
    { label: "Market Cap", value: 980.2, unit: "B" },
  ],
  revenue_trend: [
    { period: "2023 Q1", value: 28.3 },
    { period: "2023 Q2", value: 30.1 },
    { period: "2023 Q3", value: 32.8 },
    { period: "2023 Q4", value: 33.6 },
  ],
  eps_trend: [
    { period: "2023 Q1", value: 1.12 },
    { period: "2023 Q2", value: 1.32 },
    { period: "2023 Q3", value: 1.45 },
    { period: "2023 Q4", value: 1.51 },
  ],
};

export const sampleOverview = [
  { label: "P/E", value: "24.3x" },
  { label: "EBITDA Margin", value: "18.2%" },
  { label: "ROE", value: "22.5%" },
  { label: "Current Ratio", value: "1.8x" },
  { label: "CEO", value: "A. Maxwell" },
  { label: "HQ", value: "Austin, TX" },
  { label: "Founded", value: "2005" },
  { label: "Employees", value: "24,500" },
];

export const incomeStatement = [
  { label: "Revenue", value: "$33.6B" },
  { label: "COGS", value: "$12.4B" },
  { label: "Gross Profit", value: "$21.2B" },
  { label: "Operating Income", value: "$8.9B" },
  { label: "Net Income", value: "$6.1B" },
];

export const balanceSheet = [
  { label: "Cash", value: "$14.2B" },
  { label: "Total Assets", value: "$120.4B" },
  { label: "Total Liabilities", value: "$58.2B" },
  { label: "Shareholder Equity", value: "$62.2B" },
];

export const cashFlow = [
  { label: "Operating Cash Flow", value: "$7.4B" },
  { label: "Investing Cash Flow", value: "-$2.2B" },
  { label: "Financing Cash Flow", value: "-$3.1B" },
  { label: "Free Cash Flow", value: "$5.1B" },
];

export const sampleSuggestions = [
  { name: "Apple Inc.", ticker: "AAPL", domain: "apple.com" },
  { name: "Alphabet Inc.", ticker: "GOOGL", domain: "abc.xyz" },
  { name: "Reliance Industries", ticker: "RELIANCE.NS", domain: "ril.com" },
];
